export async function getPalletsOfDestinationUseCase(location_id, relocationRepository) {
    const result = await relocationRepository.get_pallets(location_id);
    
    return result;
}